import * as React from 'react';
import { Card } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

interface IProductVideoProps {
  video: GQL.IProductVideo;
  language: string;
  onEdit: (video: GQL.IProductVideo) => void;
  onDelete: (video: GQL.IProductVideo) => void;
}

class ProductVideo extends React.Component<IProductVideoProps> {

  public render() {
    const { video, language } = this.props;
    
    return (
      <Card
        hoverable={true}
        style={{ width: 480 }}
        cover={
          <iframe 
            width="480" 
            height="270" 
            src={video.url} 
            frameBorder="0" 
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen={true} 
          />}
        actions={[
          <EditOutlined key="edit" onClick={(e) => this.props.onEdit(video)} />, 
          <DeleteOutlined key="delete" onClick={(e) => this.props.onDelete(video)} />
        ]}
      >
        <Card.Meta
          // title={video && video.title && video.title[language] || <em>"without title"</em>}
          title={null}
          description={video.url}
        />
      </Card>
    );
  }
}

export default ProductVideo;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideos/ProductVideo.tsx